exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card .tweet-body {\n  padding-left: 10px;\n  overflow: hidden; }\n\n.card .card-content {\n  padding: 16px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/tweet.component.scss
// module id = 237
// module chunks = 0